<template>
    <form class="form one gcrg20" @submit="checkForm">

        <div class="input-group grg10" id="top_of_form">
            <!-- <label for="name">Name*</label> -->
            <input
                    v-model="contact.name"
                    type="text"
                    placeholder="Name*"
                    :class="`form-control '  ${typeof validationErrors !== 'undefined' && validationErrors.name ? ' is-invalid' : ''}`"
                    name="name"
                    id="name"
            >
            <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.name"></lara-error>
        </div>
        <div class="input-group grg10">
            <!-- <label for="email">Email*</label> -->
            <input
                    v-model="contact.email"
                    type="text"
                    placeholder="Email*"
                    :class="`form-control '  ${typeof validationErrors !== 'undefined' && validationErrors.email ? ' is-invalid' : ''}`"
                    name="email"
                    id="email"
            >
            <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.email"></lara-error>
        </div>
        <div class="input-group grg10">
            <!-- <label for="">Phone number*</label> -->
            <input
                    v-model="contact.phone"
                    type="text"
                    placeholder="Phone number*"
                    class="form-control"
                    :class="`form-control '  ${typeof validationErrors !== 'undefined' && validationErrors.phone ? ' is-invalid' : ''}`"
            >
            <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.phone"></lara-error>
        </div>
        <div class="input-group grg10">
            <!-- <label for="department">Department*</label> -->
            <select v-model="contact.department" name="department" id="department" class="form-control">
                <option disabled selected value="">Please choose one Department*</option>
                <option
                        value="donate"
                >Donate</option>
                <option
                        value="volunteer"
                >Volunteer</option>

            </select>
            <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.department"></lara-error>
        </div>
        <div class="input-group grg10">
            <!-- <label for="subject">Subject*</label> -->
            <input
                    v-model="contact.subject"
                    type="text"
                    id="subject"
                    placeholder="Subject*"
                    class="form-control"
                    :class="`form-control '  ${typeof validationErrors !== 'undefined' && validationErrors.subject ? ' is-invalid' : ''}`"
            >
            <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.subject"></lara-error>
        </div>
        <div class="input-group grg10">
            <!-- <label for="message">Message</label> -->
            <textarea
                    id="message"
                    v-model="contact.message"
                    type="text"
                    placeholder="Message"
                    col="1"
                    row="10"
                    class="form-control"
                    :class="`form-control '  ${typeof validationErrors !== 'undefined' && validationErrors.message ? ' is-invalid' : ''}`"
            ></textarea>
            <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.message"></lara-error>
        </div>
        <div class="button">
            <button type="submit" class="primary rounded jstart">Submit</button>
        </div>
    </form>
</template>

<script>
    import TextInput from "./TextInput";
    import Checkbox from "./Checkbox";
    import {VueTelInput} from 'vue-tel-input';
    import TextArea from "./TextArea";
    import RadioComponent from "./RadioComponent";
    import CurrencyPicker from "./CurrencyPicker";
    import PaymentMethod from "./PaymentMethod";
    import AmountComponent from "./AmountComponent";
    import CurrencyConversionHover from "./CurrencyConversionHover";
    import LaraError from "../general/LaraError";

    export default {
        name: "ContactForm",
        components: {
            TextInput,
            Checkbox,
            VueTelInput,
            TextArea,
            RadioComponent,
            CurrencyPicker,
            PaymentMethod,
            AmountComponent,
            CurrencyConversionHover,
            LaraError,
        },
        data: () => ({
            contact: {
                name: '',
                email: '',
                phone: '',
                department: '',
                subject: '',
                message: '',
            },
            submitted: false,
            validationErrors: undefined
        }),
        methods: {
            showInvalidData() {
                this.$swal.fire({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `There were some errors in the details you submitted.`,
                }).then(() => {
                    window.scrollTo(0, 0);
                });
            },
            showValidationModal() {
                this.$swal.fire({
                    icon: 'info',
                    title: 'Validating your information...',
                    // imageUrl: '/img/collage.png',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showConfirmButton: false,
                    // imageWidth: 593,
                    // imageHeight: 95,
                    backdrop: `rgba(0,0,0,0.7)`,
                    imageAlt: 'Custom image',
                    onOpen:  () => {
                        this.$swal.showLoading();
                    }
                });
            },
            checkForm(e) {
                this.submitted = true;
                e.preventDefault();
                if (process.env.MIX_APP_USE_DUMMY === 'true') {
                    this.contact = {
                        // name: 'David',
                        email: 'dblumenau@gmail.com',
                        phone: '0762628702',
                        department: 'volunteer',
                        subject: 'Testing',
                        message: 'Test message',
                    }
                }
                this.showValidationModal();
                axios.post('/contact', this.contact).then(response => {
                    if (response.data.message === 'Form submitted successfully') {
                        this.contact = {};
                        this.showAlert();
                    }
                }).catch(errors => {
                    if (errors.response.status === 422) {
                        console.log(errors, errors.response.data, errors.response.data.errors);
                        this.validationErrors = errors.response.data.errors;
                        this.validationMessage = errors.response.data.message;
                        this.submitted = false;
                        this.$swal.close();
                        this.showInvalidData();
                    }
                });
                setTimeout(() => {
                    window.scrollTo(0, 0);
                }, 2000);
                return false;
            },
            showAlert() {
                this.$swal.fire({
                    icon: 'success',
                    title: 'Thank you!',
                    html: 'Thank you for contacting to support the DL Link. We will get back to you shortly!',
                });
            }
        }
    }
</script>

<style scoped>

</style>
